import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export interface DeleteReactionMutation {
  deleteReaction: boolean;
}

export interface DeleteReactionMutationVariables {
  id: string;
}

export const DELETE_REACTION: TypedDocumentNode<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
> = gql`
  mutation DeleteReaction($id: String!) {
    deleteReaction(id: $id)
  }
`;
